import * as React from 'react';
import { getLocalization } from 'global/global';
import { useAppDispatch, useAppSelector } from 'index';
import { navRootsSelector } from 'reducers/admin/selectors';
import { showColumns, showDetail, showGrid } from 'reducers/admin/ui';
import { GridMode } from 'Interfaces/Admin';
import NavListItem from '../HierarchyNav/NavListItem';

interface AllEntry {
  mode: GridMode;
  label: string;
  icon: string;
}

const ALL_ENTRIES: AllEntry[] = [
  { mode: 'users', label: 'allUsers', icon: 'fa-user' },
  { mode: 'groups', label: 'allGroups', icon: 'fa-users' },
  { mode: 'campaigns', label: 'viewCampaigns', icon: 'fa-calendar' },
];

/**
 *  The left rail: the three "show everything" entries and the list of top level
 *  groups. Replaces the col-2 markup of admin.tmpl.jsp plus LeftView.js.
 */
export default function AdminSidebar() {
  const dispatch = useAppDispatch();
  const roots = useAppSelector(navRootsSelector);
  const ui = useAppSelector((state) => state.admin.ui);

  const allActive = (mode: GridMode) =>
    ui.view === 'grid' && ui.gridShow === 'all' && ui.gridMode === mode;

  return (
    <>
      <div className="list-group row">
        {ALL_ENTRIES.map(({ mode, label, icon }) => (
          <a
            href="#"
            key={mode}
            className={`list-group-item all ${allActive(mode) ? 'active' : ''}`}
            onClick={(e) => {
              e.preventDefault();
              dispatch(showGrid({ mode, show: 'all' }));
            }}
          >
            <div>
              <i className={`fa ${icon}`} aria-hidden="true" /> {getLocalization(label)}
            </div>
          </a>
        ))}
      </div>

      <label>{getLocalization('topLevelGroups')}</label>
      <div className="list-group leftView top-level">
        {roots.map((item) => (
          <NavListItem
            key={`${item.type}-${item.id}`}
            item={item}
            selected={ui.path.length > 0 && ui.path[0].type === item.type && ui.path[0].id === item.id}
            // onSelect={() => dispatch(showColumns({ path: [{ type: item.type, id: item.id }] }))}
            onSelect={() => dispatch(showDetail({ kind: item.type, id: item.id }))}
            onDrillDown={() => dispatch(showColumns({ path: [{ type: item.type, id: item.id }] }))}
          />
        ))}
      </div>
    </>
  );
}
